import React from "react";
import leetcode from "./icons/leetcode.svg";
import linkedin from "./icons/linkedin.svg";
import mail from "./icons/mail.svg";
import github from "./icons/github.svg";
export default function Socials(){
    return (
        <>
        <hr />
        <div className="social-container">
            <a href="https://leetcode.com/shyamswaran/" target="_blank" className="social-element">
                <img src={leetcode}alt="" />
                <p>Leetcode</p>
            </a>
            <a href="https://www.linkedin.com/in/shyamswaran" target="_blank" className="social-element">
                <img src={linkedin}alt="" />
                <p>Linkedin</p>
            </a>
            <a href="https://github.com/shyam-swaran" target="_blank" className="social-element">
                <img src={github}alt="" />
                <p>Github</p>
            </a>
        </div>
        </>
    )
}